import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

import { type AsChildProps, Slot } from "@/components/_molecules/slot.tsx";
import { useDeleteLabel } from "@/domain/label/hooks/api/use-delete-label";

type DeleteLabelActionProps = AsChildProps<React.ButtonHTMLAttributes<HTMLButtonElement>> & {
  style?: React.CSSProperties;
  className?: string;
  label: {
    id: string;
    labelGroupId?: string | null;
  };
  workspace: {
    id: string;
  };
  forceDelete?: boolean;
};

export const DeleteLabelAction = ({ label, asChild, forceDelete, ...props }: DeleteLabelActionProps) => {
  const { t } = useTranslation("common");
  const Comp = asChild ? Slot : "button";

  const { deleteLabel } = useDeleteLabel({
    onCompleted: () => {
      toast.success(t("label.deleteSuccess"), { description: t("label.deleteSuccessDescription") });
    },
    onError: () => {
      toast.error(t("label.deleteError"), { description: t("label.deleteError") });
    },
  });

  useEffect(() => {
    if (forceDelete) {
      triggerDeleteLabel();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [forceDelete]);

  async function triggerDeleteLabel() {
    await deleteLabel({ id: label.id });
  }

  function handleClick() {
    triggerDeleteLabel();
  }

  return <Comp {...props} onClick={handleClick} />;
};
